import { z } from 'zod';

export const onboardingStepId = z.enum([
  'access',
  'profile',
  'account_review',
  'license',
  'availability',
  'preferences',
  'payouts',
]);
export const onboardingStepStatus = z.enum([
  'complete',
  'action_required',
  'in_review',
  'blocked',
  'not_available',
]);
export const onboardingStep = z.object({
  id: onboardingStepId,
  title: z.string(),
  status: onboardingStepStatus,
  owner: z.enum(['you', 'review_team', 'platform']),
  requiredForBooking: z.boolean(),
  description: z.string(),
  actionPath: z
    .enum(['/profile', '/credentials', '/availability', '/find', '/payouts', '/tax-documents'])
    .nullable(),
  actionLabel: z.string().nullable(),
});
export type OnboardingStep = z.infer<typeof onboardingStep>;

/** Setup readiness is not authorization for an individual shift or payment readiness. */
export const onboardingReadiness = z.object({
  professionalId: z.string().nullable(),
  readyToFindShifts: z.boolean(),
  nextStepId: onboardingStepId.nullable(),
  steps: z.array(onboardingStep),
  licenseStates: z.array(z.string()),
  expiringCredentials: z.array(
    z.object({
      id: z.string(),
      label: z.string(),
      expiresAt: z.string(),
    })
  ),
  checkedAt: z.string(),
});
export type OnboardingReadiness = z.infer<typeof onboardingReadiness>;
